import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { stagger: { type: Number, default: 0 } }

  connect() {
    const items = this.staggerValue > 0
      ? Array.from(this.element.children)
      : [this.element]

    items.forEach(el => { el.style.opacity = "0" })

    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return
      this.observer.disconnect()
      items.forEach((el, i) => {
        el.style.animationDelay = `${i * this.staggerValue}ms`
        el.style.animationFillMode = "backwards"
        el.style.opacity = ""
        el.classList.add("animate-in", "fade-in", "slide-in-from-bottom-4", "duration-700")
      })
    }, { threshold: 0.15 })

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
